export default {
  avatar: {
    title: "แก้ไขรูปโปรไฟล์",
  },
  bindRole: {
    allServers: "เซิร์ฟทั้งหมด",
    bindFailed: "ผูกมัดตัวละครล้มเหลว",
    bindSuccess: "ผูกมัดตัวละครสำเร็จ",
    getRoleListFailed: "ไม่สามารถรับรายชื่อตัวละคร",
    getServerListFailed: "ไม่สามารถรับรายชื่อเซิร์ฟเวอร์",
    modifyTitle: "แก้ไขการผูกมัดตัวละคร",
    noRole: "ยังไม่มีตัวละคร",
    recentServers: "เซิร์ฟของท่าน",
    role: "ชื่อตัวละคร:",
    rolePlaceholder: "โปรดเลือกตัวละคร",
    server: "เซิร์ฟ:",
    serverPlaceholder: "โปรดเลือกเซิร์ฟ",
    title: "ผูกมัดตัวละคร",
  },
  commentModal: {
    placeholder: "เขียนรีวิว...",
    replyTo: "ตอบกลับ{username}",
    title: "ความคิดเห็น",
  },
  common: {
    cancel: "ยกเลิก",
    confirm: "ยืนยัน",
    landscapeTip: "กรุณาหมุนโทรศัพท์เป็นโหมดแนวตั้งเพื่อประสบการณ์ที่ดีขึ้น",
    loadMore: "เลื่อนขึ้นเพื่อโหลดเพิ่ม",
    loading: "กำลังโหลด...",
    loadingMore: "โหลดเพิ่ม...",
    noMore: "ไม่มีข้อมูลแล้ว",
    refreshFailed: "รีเฟรชล้มเหลว",
    refreshSuccess: "รีเฟรชสำเร็จ",
    submit: "ส่ง",
    all: "ทั้งหมด",
    language: "ภาษา",
  },
  error: {
    50002: "โทเค็นไม่ถูกต้องหรือหมดอายุ",
    50006: "ชื่อนี้มีผู้ใช้งานแล้ว",
    50007:
      "คุณสามารถเปลี่ยนชื่อเล่นได้เพียงเดือนละครั้ง คุณได้เปลี่ยนไปแล้วในเดือนนี้",
    50008: "แต้มไม่เพียงพอ",
    50301: "คุณไม่มีสิทธิ์ในการโพสต์",
    50302: "จำนวนการโพสต์ถึงขีดจำกัดแล้ว",
    50303: "ความยาวของเนื้อหาไม่เป็นไปตามข้อกำหนด",
    50304: "เนื้อหามีคำที่ไม่เหมาะสม โปรดแก้ไขแล้วลองใหม่อีกครั้ง",
    50308: "ไม่มีสิทธิ์เข้าถึงโพสต์นี้",
    50309: "โพสต์ถูกลบหรือย้ายไปแล้ว",
    50351: "หัวข้อถูกปิดแล้ว ไม่สามารถตอบกลับได้",
    50353: "คุณไม่มีสิทธิ์ในการตอบกลับ",
    50354: "บอร์ดนี้ไม่อนุญาตให้ตอบกลับ",
    50355: "คุณโพสต์ถี่เกินไป โปรดลองอีกครั้งในภายหลัง",
    50356: "จำนวนโพสต์ต่อชั่วโมงถึงขีดจำกัดแล้ว",
    50361: "ไม่พบความคิดเห็น",
    50500: "คุณไม่มีสิทธิ์ค้นหา",
    50501: "ฟังก์ชันค้นหาถูกปิดใช้งาน",
    50502: "เนื้อหามีคำที่ไม่เหมาะสม โปรดแก้ไขแล้วลองใหม่อีกครั้ง",
    50505: "ค้นหาบ่อยเกินไป กรุณาลองใหม่อีกครั้งในภายหลัง",
    50703: "รูปภาพไม่ผ่านการตรวจสอบ",
    50704: "เนื้อหารูปภาพไม่เหมาะสม",
    50214: "แชร์ไม่สำเร็จ: คุณยังไม่ได้เข้าร่วม@:shareModal.alliance",
    common: "ดำเนินการล้มเหลว โปรดลองใหม่ภายหลัง",
  },
  home: {
    gameName: "Puzzles & Survival",
    hasSigned: "เช็คอินแล้ว",
    loginInSuccess: "ล็อกอินสำเร็จ",
    pleaseLogin: "โปรดล็อกอินก่อน",
    loginNow: "เข้าสู่ระบบ",
    pullToRefresh: "ดึงลงเพื่อรีเฟรช",
    releaseToRefresh: "ปล่อยเพื่อรีเฟรช",
    signFailed: "เช็คอินล้มเหลว",
    signIn: "เช็คอิน",
    signInFailedTip: "เช็คอินล้มเหลว โปรดลองใหม่อีกครั้ง",
    signSuccess: "เช็คอินสำเร็จ",
    goToShop: "ไปที่ศูนย์คะแนน",
    sortByLastPost: "คอมเมนต์ล่าสุด",
    sortByTime: "ล่าสุด",
    tags: {
      activity: "กิจกรรม",
      chats: "พูดคุย",
      guide: "กลยุทธ์",
      recommend: "แนะนำ",
      news: "ข่าว",
    },
    unboundRole: "ยังไม่ผูกมัดตัวละคร",
  },
  linkModal: {
    close: "Close",
    textLabel: "Link Text",
    textPlaceholder: "Please enter link text",
    title: "Insert Link",
    urlLabel: "Link URL",
    urlPlaceholder: "Please enter link URL",
    viewTitle: "View Link",
  },
  maintenance: {
    title: "กำลังบำรุงรักษา",
    message:
      "ขออภัย ฟอรัมเกมกำลังอยู่ระหว่างการบำรุงรักษา กรุณาลองใหม่อีกครั้งในภายหลัง",
  },
  mentionModal: {
    searchPlaceholder: "ค้นหาผู้ใช้",
    title: "เลือกผู้ใช้",
  },
  nicknameModify: {
    alreadyRenamed:
      "เปลี่ยนชื่อได้เดือนละครั้งเท่านั้น เดือนนี้คุณเปลี่ยนไปแล้ว",
    changedNickname: "เปลี่ยนชื่อเล่น",
    cost: "ใช้",
    date: "วันที่",
    getMore: "รับ",
    nicknameTooShort: "ชื่อเล่นต้องมีอย่างน้อย 3 ตัวอักษร",
    coinNotEnough: "แต้มไม่เพียงพอ",
    placeholder: "กรอกชื่อเล่น",
    recordTitle: "ประวัติการแก้ไข",
    sameNickname: "ไม่สามารถใช้ชื่อซ้ำกับชื่อปัจจุบันได้",
    success: "แก้ไขเรียบร้อยแล้ว",
    viewRecord: "ดูประวัติการแก้ไข",
  },
  notice: {
    empty: "ยังไม่มีข้อความ",
    likeComment: "{username} กดไลค์คอมเมนต์ของคุณ",
    likePost: "{username} ถูกใจโพสต์ของคุณ",
    mentionComment: "{username} เมนชั่นคุณในคอมเมนต์",
    mentionPost: "{username} เมนชั่นคุณในโพสต์",
    replyComment: "{username} ตอบกลับคอมเมนต์ของคุณ",
    replyPost: "{username} ตอบกลับโพสต์ของคุณ",
    system: "แจ้งเตือนระบบ",
    tabs: {
      like: "ถูกใจ",
      mention: "กล่าวถึง",
      notification: "แจ้งเตือน",
      reply: "ตอบกลับ",
    },
    title: "การแจ้งเตือน",
  },
  operateModal: {
    confirmDelete: "ต้องการจะลบโพสต์นี้หรือไม่?",
    copyFailed: "คัดลอกไม่สำเร็จ",
    copyLink: "คัดลอกลิงก์",
    copySuccess: "คัดลอกสำเร็จ",
    delete: "ลบ",
    shareToGame: "แชร์ไปยังเกม",
    deleteFailed: "ลบไม่สำเร็จ",
    deleteSuccess: "ลบสำเร็จ",
    title: "จัดการ",
  },
  shareModal: {
    selectChannelTitle: "กรุณาเลือกช่องทางที่ต้องการแชร์",
    channelLabel: "ช่องทาง",
    channelPlaceholder: "เลือกช่องทาง",
    alliance: "สมาพันธ์",
    shareSuccess: "แชร์สำเร็จ",
    continueBrowse: "ดูต่อ",
    goToGame: "ไปดูในเกม",
    noThreadTip: "กรุณาเปิดโพสต์ก่อน",
  },
  post: {
    create: {
      contentEmpty: "เนื้อหาห้ามเว้นว่าง",
      contentPlaceholder: "คุณกำลังคิดอะไรอยู่...",
      failed: "โพสต์ล้มเหลว",
      fileTooLarge: "ขนาดไฟล์เกินขีดจำกัด（最大 {maxSize}）",
      image: "รูปภาพ",
      imageSizeLimit: "รูปภาพต้องมีขนาดไม่เกิน 5MB",
      imageUploadFailed: "อัปโหลดรูปภาพล้มเหลว",
      imageUploadSuccess: "อัปโหลดรูปภาพสำเร็จ",
      imageUploading: "กำลังอัปโหลดรูปภาพ โปรดรอสักครู่...",
      invalidFileType: "ประเภทไฟล์ไม่รองรับ",
      maxCharsReached: "ถึงขีดจำกัดจำนวนตัวอักษรสูงสุด ({max} ตัวอักษร)",
      mention: "{'@'}",
      selectBoard: "เลือกบอร์ด",
      topicLabel: "หัวข้อ",
      submit: "โพสต์",
      submitting: "กำลังโพสต์...",
      success: "โพสต์สำเร็จ",
      title: "โพสต์",
      titleEmpty: "หัวข้อห้ามเว้นว่าง",
      titlePlaceholder: "โปรดระบุหัวข้อ",
      video: "วิดีโอ",
      videoSizeLimit: "วิดีโอต้องมีขนาดไม่เกิน 50MB",
      videoUploadFailed: "อัปโหลดคลิปล้มเหลว",
      videoUploadSuccess: "อัปโหลดคลิปสำเร็จ",
      videoUploading: "กำลังอัปโหลดวิดีโอ โปรดรอสักครู่...",
    },
    title: "โพสต์",
  },
  postDetail: {
    allComments: "การตอบกลับทั้งหมด {num} รายการ",
    allReplies: "ตอบกลับทั้งหมด",
    author: "เจ้าของกระทู้",
    cancelFavorite: "เลิกบันทึกแล้ว",
    commentTooShort: "ความคิดเห็นต้องมีอย่างน้อย 5 ตัวอักษร",
    translate: "แปล",
    translating: "กำลังแปล...",
    translateSuccess: "แปลสำเร็จ",
    translateFailed: "แปลล้มเหลว",
    translatedTo: "แปลเป็น",
    earliest: "ตอบกลับเก่าสุด",
    favoriteSuccess: "บันทึกแล้ว",
    floor: "ความเห็น",
    latest: "ตอบกลับล่าสุด",
    loadFailed: "โหลดล้มเหลว",
    noContent: "ไม่มีเนื้อหา",
    onlyAuthor: "ดูเฉพาะผู้เขียน",
    reply: "ตอบกลับ",
    replyTo: "ตอบกลับ",
    sendFailed: "ส่งไม่สำเร็จ",
    sendSuccess: "ส่งสำเร็จ",
    sending: "กำลังส่ง...",
    viewOriginalPost: "ดูโพสต์ต้นฉบับ",
    writeSomething: "พูดอะไรหน่อยสิ...",
  },
  profile: {
    addLikeSuccess: "กดไลค์แล้ว",
    cancelLikeSuccess: "เลิกถูกใจแล้ว",
    communityId: "ID ชุมชน",
    editNickname: "เปลี่ยนชื่อเล่น",
    followSuccess: "ติดตามสำเร็จ",
    followed: "กำลังติดตาม",
    followers: "ผู้ติดตาม",
    follow: "กำลังติดตาม",
    likes: "การถูกใจ",
    noFavorites: "ยังไม่มีคอลเลกชัน",
    noPosts: "ยังไม่มีกิจกรรม",
    shopLabel: "ร้านค้าคะแนน",
    tabs: {
      favorites: "คอลเลกชันของฉัน",
      posts: "โพสต์ของฉัน",
    },
    title: "ศูนย์ส่วนตัว",
    unfollowSuccess: "เลิกติดตามสำเร็จ",
  },
  search: {
    btn: "ค้นหา",
    empty: "ไม่พบผลการค้นหา",
    filter: {
      dateline: "ล่าสุด",
      title: "จัดเรียง",
      views: "ยอดนิยม",
    },
    historyTitle: "ประวัติการค้นหา",
    hotTitle: "ค้นหายอดนิยม",
    relatedPosts: "โพสต์ที่เกี่ยวข้อง",
    tabs: {
      post: "โพสต์",
      user: "ผู้ใช้",
    },
  },
  setting: {
    about: "เกี่ยวกับเรา",
    logout: "ล็อกเอาท์",
    logoutSuccess: "ออกจากระบบแล้ว",
    privacy: "นโยบายความเป็นส่วนตัว",
    service: "ข้อกำหนดบริการ",
    title: "การตั้งค่า",
  },
  shop: {
    emptyTip: "ร้านค้ากำลังเตรียมการ โปรดติดตาม~",
    record: "ประวัติการแลกเปลี่ยน",
    title: "ศูนย์แลกเปลี่ยน",
    bindRole: "ผูกมัดตัวละคร",
    switchRole: "เปลี่ยนตัวละคร",
    tabs: {
      tasks: "ภารกิจคะแนน",
      rewards: "แลกเปลี่ยนรางวัล",
    },
    taskInProgress: "กำลังดำเนินการ",
    taskCompleted: "เสร็จสิ้น",
    goToComplete: "ไปเคลียร์",
    exchange: "แลกเปลี่ยน",
    exchanged: "แลกเปลี่ยนแล้ว",
    exchangeConfirmTitle: "ยืนยันการแลกเปลี่ยน?",
    currentCoins: "คะแนนปัจจุบัน",
    costCoins: "คะแนนที่ใช้",
    receiveRole: "ตัวละครผู้รับ",
    exchangeSuccess: "แลกเปลี่ยนสำเร็จ",
    exchangeFailed: "แลกเปลี่ยนล้มเหลว",
  },
  exchangeRecord: {
    time: "เวลา",
    content: "เนื้อหา",
    points: "คะแนน",
    empty: "ไม่มีประวัติการแลกเปลี่ยน",
  },
  tabBar: {
    home: "หน้าแรก",
    notice: "ข้อความ",
    profile: "ของฉัน",
  },
  time: {
    hoursAgo: "{hours} ชั่วโมงที่แล้ว",
    minutesAgo: "{minutes} นาทีที่แล้ว",
  },
};
